/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import { useCallback, useEffect } from 'react';
import { channelTalkConstant } from '@src/constants/channelTalkConstant';
import { useMainInfo } from '@hooks/main';

export const useChannelTalk = () => {
  const [mainInfo, setMainInfo] = useMainInfo();

  const boot = useCallback(() => {
    if (!window.ChannelIO) {
      let ch = function () {
        // @ts-ignore
        ch.c(arguments);
      };
      // @ts-ignore
      ch.q = [];
      // @ts-ignore
      ch.c = function (args) {
        // @ts-ignore
        ch.q.push(args);
      };
      window.ChannelIO = ch;

      window.ChannelIOInitialized = true;
      const mapScript = document.createElement('script');
      mapScript.src = `https://cdn.channel.io/plugin/ch-plugin-web.js`;

      document.body.appendChild(mapScript);
      mapScript.addEventListener('load', () => {
        window.ChannelIO('boot', channelTalkConstant, function onBoot(err: unknown, user: unknown) {
          if (err) {
            console.log('boot error:', err)
          }
          setMainInfo({
              ...mainInfo,
            isBooted: true
          })
        });
        window.ChannelIO('onShow', function () {
          console.log('show');
          setMainInfo({
            ...mainInfo,
            isVisibleChannelTalk: true,
          });
        });
        window.ChannelIO('onHide', function () {
          console.log('hide');
          setMainInfo({
            ...mainInfo,
            isVisibleChannelTalk: false,
          });
        });
      });
    } else if (!mainInfo.isBooted) {
      console.log('boot');
      window.ChannelIO('boot', channelTalkConstant, function onBoot(err: unknown, user: unknown) {
        if (err) {
          console.log('boot error:', err)
        }
        setMainInfo({
            ...mainInfo,
          isBooted: true
        })
      });
    }
  }, [window.ChannelIO, mainInfo]);
  useEffect(() => {
    boot();
  }, [])

  const shutdown = useCallback(() => {
    window.ChannelIO('shutdown');
  }, [window.ChannelIO]);

  const show = useCallback(() => {
    window.ChannelIO('showChannelButton');
  }, [window.ChannelIO]);

  const hide = useCallback(() => {
    window.ChannelIO('hideChannelButton');
  }, [window.ChannelIO]);

  return {
    boot: boot,
    shutdown: shutdown,
    show: show,
    hide: hide,
  };
};
